import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Spinner from 'shared/components/Spinner';
import { OAUTH } from 'shared/constants';
import { userportal, createUserportalLink } from 'shared/routes';
import { selectors } from 'userportal/ducks/auth';
import Page from 'userportal/components/Page';

const Request = () => {
  const { t } = useTranslation('userportal');
  const navigate = useNavigate();
  const loggedIn = useSelector(selectors.isLoggedIn);

  useEffect(() => {
    if (!loggedIn) {
      const state = window.crypto.randomUUID().replace(/-/g, '');
      localStorage.setItem(OAUTH.GOOGLE.STATE_KEY, state);

      const params = {
        scope: 'https://www.googleapis.com/auth/userinfo.profile https://www.googleapis.com/auth/userinfo.email',
        // access_type: 'offline',
        // include_granted_scopes=true&
        response_type: 'code',
        state,
        redirect_uri: createUserportalLink(userportal.oauth.google.callbackUrl),
        client_id: OAUTH.GOOGLE.CLIENT_ID,
      };

      const qs = Object.entries(params).map(([key, value]) => `${key}=${value}`).join('&');
      window.location = `https://accounts.google.com/o/oauth2/v2/auth?${qs}`;
    }
  }, []);

  useEffect(() => {
    if (loggedIn) {
      navigate(userportal.root, { replace: true });
    }
  }, [loggedIn]);

  return (
    <Page relative={false}>
      <Spinner splash>{t('page.oauth.inProgress')}</Spinner>
    </Page>
  );
};

export default Request;
